module.exports = __webpack_public_path__ + "static/media/HQ18_nutrients.4d6a4dce.png";